import {Component, OnInit} from '@angular/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {RouterModule} from '@angular/router';
import {ServerVersionService} from './server-version.service';

@Component({
  selector: 'app-top-nav',
  imports: [RouterModule, MatToolbarModule, MatButtonModule],
  templateUrl: 'top-nav.component.html',
  styleUrls: ['top-nav.component.scss']
})
export class TopNavComponent implements OnInit {
  version!: string;
  testEnv?: string;

  constructor(serverVersionService: ServerVersionService) {
    serverVersionService.subscribe(({client}) => this.version = client);
  }

  async ngOnInit() {
    const {hostname} = window.location;
    this.testEnv = hostname === 'iwofurn-api.supplycanvas.com' ? undefined : hostname.split('.')[0];
  }
}
